function hasAiError(data) {
  return Boolean(data && typeof data === 'object' && typeof data.error === 'string' && data.error.trim())
}

export async function readAiJson(response, markUnavailable) {
  let data
  try {
    data = await response.json()
  } catch (error) {
    markUnavailable()
    throw error
  }
  if (!response.ok || hasAiError(data)) {
    markUnavailable()
    const error = new Error(data?.error || `AI request failed with status ${response.status}.`)
    error.code = data?.code || 'ai_request_failed'
    error.retryable = Boolean(data?.retryable)
    throw error
  }
  return data
}
